<template>
    <div id="app">
    <component v-bind:is="layout"></component>
    </div>
</template>
<script>
    import defaultLayout from './components/layouts/defaultLayout.vue';
    import loginLayout from './components/layouts/loginLayout.vue';
    export default {
        name: 'app',
        computed: {
            layout() {
                return this.$store.getters.layout
            }
        },
        metaInfo: {
            meta: [
                { charset: 'utf-8' },
            ]
        },
        components: {
            defaultLayout,
            loginLayout
        },
        methods: {
        }
    }
</script>
